import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const SunIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="sun" ref={ref} {...props}>
      <path d="M12.11,16.71a4.65,4.65,0,1,1,4.64-4.64A4.65,4.65,0,0,1,12.11,16.71Zm0-7.79a3.15,3.15,0,1,0,3.14,3.15A3.15,3.15,0,0,0,12.11,8.92ZM22.75,12a.76.76,0,0,0-.75-.75H20.09a.75.75,0,0,0,0,1.5H22A.76.76,0,0,0,22.75,12ZM4.68,12a.75.75,0,0,0-.75-.75H2a.75.75,0,1,0,0,1.5H3.93A.75.75,0,0,0,4.68,12Zm8.08,10V20.08a.75.75,0,0,0-1.5,0V22a.75.75,0,0,0,1.5,0Zm0-18.07V2a.75.75,0,0,0-1.5,0V3.92a.75.75,0,0,0,1.5,0ZM19.6,19.59a.75.75,0,0,0,0-1.06l-1.06-1.05a.74.74,0,0,0-1.06,0,.75.75,0,0,0,0,1.06l1.06,1.05a.73.73,0,0,0,.53.22A.74.74,0,0,0,19.6,19.59ZM6.53,6.53a.77.77,0,0,0,0-1.07l-1.06-1a.74.74,0,0,0-1.06,0,.75.75,0,0,0,0,1.06L5.47,6.53a.77.77,0,0,0,1.06,0ZM5.47,19.59l1.06-1.05a.75.75,0,0,0,0-1.06.74.74,0,0,0-1.06,0L4.41,18.53a.75.75,0,0,0,0,1.06.74.74,0,0,0,.53.22A.73.73,0,0,0,5.47,19.59ZM18.54,6.53,19.6,5.47a.75.75,0,0,0,0-1.06.74.74,0,0,0-1.06,0l-1.06,1a.77.77,0,0,0,0,1.07.77.77,0,0,0,1.06,0Z" />
    </Icon>
  ),
) as IconWithRender;

SunIcon.displayName = 'SunIcon';
SunIcon.renderIcon = (props) => <SunIcon {...props} />;
export default SunIcon;
